module.exports = __webpack_public_path__ + "centric-mockup@2x.CY-Avjt5.png";